import './activeCall.scss';

import React, { Component } from 'react';
import { useState, useEffect, createRef } from 'react';
import useDimensions from "react-cool-dimensions";

import { sendWebRTCSdp, sendWebRTCCandidate, sendWebRTCHangup, answerCall } from '../../../actions/rtcActions'

import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles';

import { Button, Paper, InputBase, Divider, IconButton, ButtonBase, Typography, Menu, MenuItem, Fab } from '@material-ui/core'
import { CallEndTwoTone as HangUpIcon } from '@material-ui/icons';

import { red } from '@material-ui/core/colors';

import { Spreads, Decks } from '../../../constants';
import { Table } from '../../parts/spread/Table';

function setMediaBitrates(sdp, videoRate = 250, audioRate = 50) {
    let f = navigator.userAgent.search("Firefox");
    let modifier = 'AS';
    // if (f > -1) {
    //     videoRate = (videoRate >>> 0) * 1000;
    //     audioRate = (audioRate >>> 0) * 1000;
    //     modifier = 'TIAS';
    // }

    //find the correct m lines (video and audio)
    var lines = sdp.sdp.split("\n");
    let i = 0;
    while (i < lines.length) {
        //if we find an m-line
        if (lines[i].indexOf("m=") === 0) {
            let video = lines[i].indexOf("m=video") === 0;
            let audio = lines[i].indexOf("m=audio") === 0;

            if (video || audio) {
                while(i < lines.length && (lines[i].indexOf("i=") === 0 || lines[i].indexOf("c=") === 0)) {
                    i++;
                }

                // If we're on a b line, replace it
                if (i < lines.length && lines[i].indexOf("b") === 0) {
                    lines[i] = `b=${modifier}:${video ? videoRate : audioRate}`;
                } else if (i == lines.length) {
                    lines.push(`b=${modifier}:${video ? videoRate : audioRate}`);
                    i++;
                } else {
                    i++;
                    lines.splice(i, 0, `b=${modifier}:${video ? videoRate : audioRate}`);
                }
            }
        }
        i++;
    }
    
    let s = lines.join("\n");    
    return { type : sdp.type, sdp : s };
}   

const ColorButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText(red[700]),
      backgroundColor: red[700],
      '&:hover': {
        backgroundColor: red[900],
      },
    },
  }))(Button);

const mapState = state => ({
    activeConversationId : state.rtc.activeConversation?.id,
    initiator : state.rtc.activeConversation?.initiator,
    useVideo : state.rtc.activeConversation?.useVideo,
    media : state.rtc.media,
    peers : state.rtc.activeConversation?.peers
  });


const pc_config = {
    iceServers : [
        {
            urls : 'stun:stun.l.google.com:19302',                
        },
        {
            urls : 'turn:turn.24readings.com:3478',
            credential: 'password',
            username: 'readings'
        }
    ]
};

//globallt define 1 peerconnection (1 conversation at 1 moment in time (for now))
let peerConnection = null;
let remoteRtcProcessed = 0;

const PeerLink = (props) => {
    const { activeConversationId, initiator, useVideo, media, peers } = useSelector(mapState);
    const dispatch = useDispatch();

    //run this effect everytime the activeConverstaion changes
    useEffect(() => {
        //active converstion has changed
        if (activeConversationId) {
            //set up a peer connection                        
            let pc = peerConnection = new RTCPeerConnection(pc_config);
            pc.theCurrentConnection = activeConversationId;

            pc.onicecandidate = (e) => {                
                if (e.candidate?.candidate) {
                    dispatch(sendWebRTCCandidate(activeConversationId, e.candidate));
                }
            };

            pc.oniceconnectionstatechange = (e) => {
                if (e.target.iceConnectionState.toLowerCase() === "connected") {
                    //do we need this??
                    console.log("CONNECTED");
                }
            };

            pc.ontrack = (e) => {
                if (props.remoteVideoRef?.current) {
                    let vd = props.remoteVideoRef.current;
                    vd.srcObject = e.streams[0];
                }                
            };

            if (initiator) {
                //we set up the channel:
                let dataChannel = pc.createDataChannel("cardEvt", {
                    ordered: true,
                    maxPacketLifeTime: 3000, // in milliseconds
                });
                pc.myDataConnecton = dataChannel;

                dataChannel.onmessage = (event) => {
                    if (event.data.indexOf("CHOOSESPREAD:") > -1) {
                        props.remoteSpreadChosen(event.data.substring(13));
                        return;
                    }
                    if (event.data.indexOf("SHUFFLE") > -1) {
                        props.remoteCardShuffle();
                        return;
                    }
                    if (event.data.indexOf("ZOOM") > -1) {   
                        props.remoteCardZoom(event.data.substring(5));
                        return;
                    }
    
                    props.remoteCardChosen(JSON.parse(event.data));                
                };
            }

            return () => {
                //stop all stuff
                //senders are stopped in the media dependant useEffect
                pc.getReceivers().forEach(s => s.track && s.track.stop());
                pc.close(); 

                props.remoteSpreadChosen(null);
                peerConnection = null;
                remoteRtcProcessed = 0;
            }
        }        
    }, [ activeConversationId ]);

    // Run this side effect everytime the overview changes 
    //most should be run only once
    useEffect(() => {
        let stream = media?.stream;

        if (stream) {
            //also set the streams onto the peerconnection tracks
            if (peerConnection) {
                let pc = peerConnection;
                stream.getTracks().forEach(track => {
                    pc.addTrack(track, stream);
                });

                if (initiator) {
                    pc
                        .createOffer({ offerToReceiveVideo : useVideo ? 1 : 0 })
                        .then(sdp => {
                            pc.setLocalDescription(sdp);

                            let newSdp = setMediaBitrates(sdp);
                            dispatch(sendWebRTCSdp(activeConversationId, newSdp));
                        })
                        .catch(e => {});
                }
            }

            return () => {
                stream.getTracks().forEach(track => track.stop());
            }
        }
    }, [ media ]);

    useEffect(() => {
        if (peers) {
            //presume only 1 peer (for now)
            var thePeers = Object.keys(peers);
            for (let p of thePeers) {
                let rtcObj = peers[p];
                let pc = peerConnection;

                if (remoteRtcProcessed === 0) {
                    remoteRtcProcessed = 1;

                    pc.setRemoteDescription(new RTCSessionDescription(rtcObj.sdp));
                    for (let candidate of rtcObj.candidates) {
                        pc.addIceCandidate(new RTCIceCandidate(candidate));
                    }
                    
                    if (!initiator) {
                        pc
                            .createAnswer({ offerToReceiveVideo : useVideo ? 1 : 0 })
                            .then(sdp => {
                                pc.setLocalDescription(sdp);

                                let newSdp = setMediaBitrates(sdp);
                                dispatch(sendWebRTCSdp(activeConversationId, newSdp));                            
                            })
                            .catch(e => { console.log(e) });
                        
                        // when we receive a channel:
                        pc.ondatachannel = (evt) => {
                            let dataChannel = pc.myDataConnecton = evt.channel;                
                            dataChannel.onmessage = (event) => {
                                if (event.data.indexOf("CHOOSESPREAD:") > -1) {
                                    props.remoteSpreadChosen(event.data.substring(13));
                                    return;
                                }
                                if (event.data.indexOf("SHUFFLE") > -1) {
                                    props.remoteCardShuffle();
                                    return;
                                }
                                if (event.data.indexOf("ZOOM") > -1) {   
                                    props.remoteCardZoom(event.data.substring(5));
                                    return;
                                }
                
                                props.remoteCardChosen(JSON.parse(event.data));                
                            };        
                        };
                    }
                } else {                    
                    if (rtcObj.lastMsg === 'SDP') {
                        pc.setRemoteDescription(new RTCSessionDescription(rtcObj.sdp));
                    } else {
                        pc.addIceCandidate(new RTCIceCandidate(rtcObj.lastMsg));
                    }
                }
            }
            
            return () => {
                
            }
        }
    }, [ peers ]);

    useEffect(() => {
        if (props.userSelected?.length && peerConnection?.myDataConnecton) {
            //get the last card
            let channel = peerConnection.myDataConnecton;
            let card = props.userSelected[props.userSelected.length - 1];
            
            let msg = JSON.stringify(card);
            channel.send(msg);
        }
    }, [ props.userSelected ]);

    useEffect(() => {
        if (props.userSelectedSpread && peerConnection?.myDataConnecton) {
            //get the last card
            let channel = peerConnection.myDataConnecton;
            
            let msg = "CHOOSESPREAD:" + props.userSelectedSpread;
            channel.send(msg);
        }
    }, [ props.userSelectedSpread ]);

    useEffect(() => {
        if (props.userEnlarged && peerConnection?.myDataConnecton) {
            //get the last card
            let channel = peerConnection.myDataConnecton;
            let card = props.userEnlarged[props.userEnlarged.length - 1];
            
            let msg = "ZOOM:" + card;
            channel.send(msg);
        }
    }, [ props.userEnlarged ]);

    return null;
}

const RealTimeTable = (props) => {
    const decktype = "TAROT";
    const deckKey = "vibrant";

    const { ref, width, height } = useDimensions();

    return <div className="tableContainer" ref={ref}>
        {props.spread &&
        <Table
            deckType={decktype}                
            deck={deckKey}
            spread={props.spread}

            rnd={props.r}
            cardPositions={props.cardPositions}
            enlarged={props.enlarged}
            onZoomIn={props.onZoomIn}
            onSelectCard={props.selectCard}
            locale={props.language}
            showHand={true}

            width={width}
            height={height}
            showReaderAids={window.consultantApp}
            onReaderAidClicked={props.onReaderAidClicked}         
        />}
    </div>
}


class ActiveCall extends Component {
    constructor(props) {
        super(props);

        this.localVideoRef = createRef();
        this.remoteVideoRef = createRef();
        this.state = {};
    }

    remoteSpreadChosen = (spread) => {
        this.setState({ spread : spread, r: Math.random(), cardPositions : [], enlarged : {}, userSelected : [], userEnlarged : [] });
    }

    remoteCardChosen = (data) => {
        let newPositions = this.state.cardPositions.concat([data]);
        this.setState({ cardPositions : newPositions });
    }

    remoteCardZoom = (cardNr) => {
        let enlarged = { ...this.state.enlarged };
        enlarged[cardNr] = !enlarged[cardNr];
        this.setState({ enlarged : enlarged });
    }

    remoteCardShuffle = () => {
        this.setState({ cardPositions : [], r: Math.random(), enlarged : {}, userSelected : [], userEnlarged : [] });
    }

    hangupClicked() {
        this.props.sendWebRTCHangup(this.props.activeConversation?.id);
    }

    chooseSpreadClicked(evt) {
        this.setState({ anchorEl : evt.currentTarget });
    }

    handleCloseMenu() {
        this.setState({anchorEl : null});
    }

    localSelectedCard(card) {
        let userSelected = this.state.userSelected || [];
        
        //also local
        let newPositions = this.state.cardPositions.concat([card]);
        this.setState({ cardPositions : newPositions, userSelected : userSelected.concat([card]) });        
    }

    localZoomInCard(card) {
        if (!window.consultantApp) return; //nothing happens

        let userEnlarged = this.state.userEnlarged || [];

        let enlarged = { ...this.state.enlarged };
        enlarged[card] = !enlarged[card];

        this.setState({ enlarged : enlarged, userEnlarged : userEnlarged.concat([card]) });
    }

    onReaderAidClicked(card, el) {
        //create a modal with the reader aids

        //we know the spread, we know the positions from state, we know which card from arguments
        this.setState({readerAidEl : el, cardExplanation : card});
    }

    handleCloseReaderAid() {
        this.setState({readerAidEl : null});
    }

    handleSpreadLinkClick(m) {
        this.setState({ anchorEl : null, r: Math.random(), cardPositions:[], spread : m.spread, localSpread : m.spread, userSelected : [], userEnlarged : [] });
    }

    getGetCurrentReaderAid(language) {
        let spreads = Object.keys(Spreads).map(key => Spreads[key]);
        spreads.sort((a, b) => a.positions.length - b.positions.length);
        
        let spread = Spreads[this.state.spread];
        if (spread == null) return null;

        let idx = this.state.cardPositions.findIndex(c => c.filename === this.state.cardExplanation?.filename);
        if (idx < 0) return null;

        let images = [];
        spread.positions.forEach((p, j) => {
            images.push(<rect
                key={`cardpos-${j}`}
                style={{ opacity : 0.9, pointerEvents : 'none', transformOrigin: `${p.centerX}px ${p.centerY}px`, transform: `rotate(${p.rotation}rad)` }}
                stroke="#000000"
                fill={j === idx ? "#990000" : "#999999"}
                x={p.centerX - spread.cardWidth / 2}
                y={p.centerY - spread.cardHeight / 2}
                width={spread.cardWidth}
                height={spread.cardHeight} />);
        });

        let card = this.state.cardExplanation;


        let positionTitle = spread.positions[idx].title || {};
        positionTitle = positionTitle[language] || positionTitle.nl;

        let description = spread.positions[idx].description || {};
        description = description[language] || description.nl;

        return <MenuItem>
            <figure>
                <svg viewBox={`0 0 ${spread.width}  ${spread.height}`}>
                    {images}
                </svg>
            </figure>
            <div>                
                <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginTop : '1ex' }}>Locatie {idx + 1}: {positionTitle}</Typography>
                <Typography variant="body2">{description}</Typography>

                <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginTop : '1ex' }}>{card[language]?.name || card.nl.name} ({card[language]?.theme || card.nl.theme})</Typography>
                <Typography variant="body2" style={{ maxWidth : '40em', display: 'block', whiteSpace: 'initial' }} dangerouslySetInnerHTML={{__html: card[language]?.description || card.nl.description}}></Typography>

                <Typography variant="subtitle2" style={{ fontWeight: 'bold', marginTop : '1ex' }}>Vragen bij deze kaart:</Typography>
                <Typography variant="body2" style={{ maxWidth : '40em', display: 'block', whiteSpace: 'initial' }}>
                    <ul>{(card[language]?.questions || card.nl.questions || []).map((q,i) => <li key={`q-${i}`} dangerouslySetInnerHTML={{__html: q}}></li>)}</ul>
                </Typography>
            </div>
            
        </MenuItem>        
    }

    getSpreadList(language) {
        let spreads = Object.keys(Spreads).map(key => Spreads[key]);
        spreads.sort((a, b) => a.positions.length - b.positions.length);

        return spreads.map((spread, i) => {
            let images = [];
            spread.positions.forEach((p, j) => {
                images.push(<rect
                    key={`cardpos-${i}-${j}`}
                    style={{ opacity : 0.9, pointerEvents : 'none', transformOrigin: `${p.centerX}px ${p.centerY}px`, transform: `rotate(${p.rotation}rad)` }}
                    stroke="#000000"
                    fill="#999999"
                    x={p.centerX - spread.cardWidth / 2}
                    y={p.centerY - spread.cardHeight / 2}
                    width={spread.cardWidth}
                    height={spread.cardHeight} />);
            });

            let fn = () => this.handleSpreadLinkClick({ deckType: 'TAROT', spread : spread.id });

            return (<MenuItem key={`spread-${spread.id}`} onClick={fn} >
                <figure>
                    <svg viewBox={`0 0 ${spread.width}  ${spread.height}`}>
                        {images}
                    </svg>
                </figure>
                <div>
                    <Typography variant="subtitle2" style={{ fontWeight: 'bold' }} noWrap>{spread.text[language]?.title || spread.text.nl.title}</Typography>
                    <Typography variant="body2" style={{ maxWidth : '40em', display: 'block', whiteSpace: 'initial' }}>{spread.text[language]?.description || spread.text.nl.description}</Typography>
                </div>
            </MenuItem>);
        });        
    }

    render() {
        let props = this.props;
        
        return <div id="activeCall" className={props.activeConversation?.id ? 'active' : ''} >
            
            <PeerLink
                localVideoRef={this.localVideoRef}
                remoteVideoRef={this.remoteVideoRef}

                remoteSpreadChosen={(spread) => this.remoteSpreadChosen(spread)}
                remoteCardChosen={(card) => this.remoteCardChosen(card)}
                remoteCardZoom={(cardNr) => this.remoteCardZoom(cardNr)}
                remoteCardShuffle={() => this.remoteCardShuffle()}              

                userSelected={this.state.userSelected}
                userSelectedSpread={this.state.localSpread}
                userEnlarged={this.state.userEnlarged}
            />

            <RealTimeTable {...this.state}
                language={props.language}
                selectCard={(c) => this.localSelectedCard(c)}
                onZoomIn={(c) => this.localZoomInCard(c)}
                onReaderAidClicked={(c, e) => this.onReaderAidClicked(c, e)}
                />

            <video className="localvideo" ref={this.localVideoRef} autoPlay={true} playsInline={true} muted={true}></video>
            <video className="remotevideo secondary" ref={this.remoteVideoRef} autoPlay={true} playsInline={true}></video>

            <div className="controls">
                {window.consultantApp && <Button
                    onClick={(e) => this.chooseSpreadClicked(e)}
                    variant="contained">Choose Spread</Button> }

                &nbsp;

                <ColorButton
                    onClick={(e) => this.hangupClicked()}
                    variant="contained"
                    startIcon={<HangUpIcon />}
                >Hang up</ColorButton>

                <Menu
                    className="readeraidsmenu"
                    anchorEl={this.state.readerAidEl}
                    keepMounted
                    open={Boolean(this.state.readerAidEl)}
                    onClose={() => this.handleCloseReaderAid()}>
                    {this.getGetCurrentReaderAid(props.language)}
                </Menu>

                <Menu
                    className="leggingenmenu"
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={Boolean(this.state.anchorEl)}
                    onClose={() => this.handleCloseMenu()}>
                    {this.getSpreadList(props.language)}
                </Menu>
            </div>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        activeConversation : state.rtc.activeConversation,
        language : state.profile.language || 'en' //TODO: use context variable ...
    };  
};

const mapDispatchToProps = dispatch => {
    return {
        sendWebRTCHangup : (conversationId) => {
            dispatch( sendWebRTCHangup(conversationId) )
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)( ActiveCall );